import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
import '../elements/regionPopup';
import { giftCardHero } from '../apps/giftCardHero';
import { backToTopButton } from '../elements/backToTopButton';
import { copyButtons } from '../elements/copyButtons';
import { forms } from '../elements/forms';
import { announcementBar } from '../sections/announcementBar';
import { articleGrid } from '../sections/articleGrid';
import { appWrapper } from '../sections/appWrapper';
import { bannerAndDrawer } from '../sections/bannerAndDrawer';
import { bannerCarousel } from '../sections/bannerCarousel';
import { blogFilters } from '../sections/blogFilters';
import { checkoutButton, updateCartDrawerElements, updateCartCount, viewCartDataLayer } from '../sections/cartDrawer';
import { contentCarousel } from '../sections/contentCarousel';
import { customerAccounts } from '../sections/customerAccounts';
import { desktopNav } from '../sections/desktopNav';
import { editorialCarousel } from '../sections/editorialCarousel';
import { editorialHero } from '../sections/editorialHero';
import { editorialProductCarousel } from '../sections/editorialProductCarousel';
import { featuredArticlesCarousel } from '../sections/featuredArticlesCarousel';
import { fiftyFiftyCollage } from '../sections/fiftyFiftyCollage';
import { hoverImageList } from '../sections/hoverImageList';
import { imageCarousel } from '../sections/imageCarousel';
import { imageCarouselWithDots } from '../sections/imageCarouselWithDots';
import { largeAccordion } from '../sections/largeAccordion';
import { loginRegister } from '../sections/loginRegister';
import { mediaBanner } from '../sections/mediaBanner';
import { megaMenu } from '../sections/megaMenu';
import { parallaxBanner } from '../sections/parallaxBanner';
import { product } from '../sections/product';
import { productCarousel } from '../sections/productCarousel';
import { regionSelector } from '../sections/regionSelector';
import { search } from '../sections/search';
import { stockists } from '../sections/stockists';
import { tabbedContent } from '../sections/tabbedContent';
import { cartDrawerDonation } from '../snippets/cartDrawerDonation';
import { cartDrawerDiscount } from '../snippets/cartDrawerDiscount';
import { cartDrawerGiftWrapping } from '../snippets/cartDrawerGiftWrapping';
import { cartDrawerRecommendations } from '../snippets/cartDrawerRecommendations';
import { productTile } from '../snippets/productTile';
import initCompanionSystem from '../companionSystem';
const loadBannerHoverReveal = () => {
    if (!document.getElementById('banner-hover-reveal-canvas'))
        return;
    import(/* webpackChunkName: "banner-hover-reveal" */ '../sections/bannerHoverReveal')
        .then(({ bannerHoverReveal }) => bannerHoverReveal())
        .catch((err) => console.error('Failed to load bannerHoverReveal', err));
};
document.addEventListener('shopify:section:load', loadBannerHoverReveal);
docReady(() => {
    giftCardHero();
    backToTopButton();
    copyButtons();
    forms();
    announcementBar();
    articleGrid();
    appWrapper();
    bannerAndDrawer();
    bannerCarousel();
    blogFilters();
    checkoutButton();
    updateCartDrawerElements();
    updateCartCount();
    viewCartDataLayer();
    contentCarousel();
    customerAccounts();
    desktopNav();
    editorialCarousel();
    editorialHero();
    editorialProductCarousel();
    featuredArticlesCarousel();
    fiftyFiftyCollage();
    loadBannerHoverReveal();
    hoverImageList();
    imageCarousel();
    imageCarouselWithDots();
    largeAccordion();
    loginRegister();
    mediaBanner();
    megaMenu();
    parallaxBanner();
    product();
    productCarousel();
    regionSelector();
    search();
    stockists();
    tabbedContent();
    cartDrawerDonation();
    cartDrawerDiscount();
    cartDrawerGiftWrapping();
    cartDrawerRecommendations();
    productTile();
});
// Initialize companion system globally (handles its own timing)
initCompanionSystem();
